import { TypeAnimation } from 'react-type-animation'
import styled from 'styled-components'

type SequenceType = (string | number)[]

interface ChatAnimationProps {
    customSequence?: SequenceType
}

const ChatAnimation = ({ customSequence }: ChatAnimationProps) => (
    <Container>
        <Text>
            <TypeAnimation
                sequence={
                    customSequence
                        ? customSequence
                        : [
                              10,
                              '',
                              50,
                              'Current trends in crypto',
                              6000,
                              'How to install Bittensor',
                              6000,
                              'Suggest 10 web extensions students can use to increase productivity',
                              6000,
                              'What is the best time of year to visit Hawaii?',
                              6000,
                          ]
                }
                speed={55}
                wrapper='span'
                repeat={Infinity}
            />
        </Text>
    </Container>
)

export default ChatAnimation

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    max-width: 3xl;
    margin: 0 auto;
`

const Text = styled.span`
    background: linear-gradient(to right, gray 400, gray 500, gray 500);
    background-clip: text;
    color: ${({ theme }) => theme.body.textColorSecondary};

    font-weight: 500;
    font-size: 2.5rem;
    line-height: 2.5rem;
    &:after {
        background: gray 500;
        @media (prefers-color-scheme: dark) {
            background: linear-gradient(to right, indigo 100, indigo 200);
        }
    }
`

export const StyledChatAnimationWrapper = styled.div`
    width: 100%;
    height: 100%;

    display: flex;

    justify-content: center;
`
